export default "__VITE_ASSET__LHdPUnDF__"